import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Order details',
  sections: {
    driver_info: 'Driver info',
    order_info: 'Order info',
    price_info: 'Price info',
    adjustments: 'Adjustments',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Takeaway',
    [ORDER_METHODS.delivery]: 'Delivery',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Room service',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Table service',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Zimmernummer',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Tischnummer',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'This order is pending approval',
    [FULFILLMENT_STATUSES.reviewed]: 'This order is pending approval',
    [FULFILLMENT_STATUSES.accepted]: 'This order is currently being processed',
    [FULFILLMENT_STATUSES.preparing]: 'This order is currently being processed',
    [FULFILLMENT_STATUSES.ready]: 'This order is ready to be picked up by customer',
    [FULFILLMENT_STATUSES.on_delivery]: 'This order is being delivered to the customer',
    [FULFILLMENT_STATUSES.picked]: 'This order was successfully fulfilled',
    [FULFILLMENT_STATUSES.rejected]: 'This order has been rejected and refunded',
    default: 'This order was successfully fulfilled',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Requested by customer',
    [REFUND_REASONS.Reclamation]: 'Reclamation',
    [REFUND_REASONS.CommunicationError]: 'Communication error',
    [REFUND_REASONS.Other]: 'Other',
    [REFUND_REASONS.Dispute]: 'Customer dispute',
    dispute_win: 'Won customer dispute',
    null: '',
    undefined: '',
  },
  labels: {
    discount: 'Discount',
    driver_name: 'Driver name',
    driver_phone_number: 'Driver phone',
    pin_code: 'PIN',
    invoice_payment: 'Payment via invoice',
    paid_in_cash: 'Payment in cash',
    customer_paid_online: 'Customer paid online',
    phone: 'Tel',
    email: 'Email',
    points_used: 'This order includes a loyalty point reward redeemed by a loyal customer',
    delivery: 'Delivery',
    pickup: 'Pickup',
    original: 'Original',
    delivery_fee: 'Delivery fee',
    tip: 'Tip',
    service_fee: 'Online processing',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'PayPal fee',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Percentage off by total applied',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Percentage off by products applied',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Amount off by products applied',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Amount off by total applied',
      [OFFER_KIND.BOGO]: 'Bogo applied',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo half price applied',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Free item by products applied',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Free item by total applied',
      GiftCard: 'Gift card applied',
      Reward: 'Loyalty points applied',
      CashbackAccount: 'Loyalty points applied',
      PromoCodeComponent: 'Promo applied',
      Offer: 'Offer applied',
    },
    total_discount: 'Promo applied',
    tax: 'Taxes',
    total: 'Total',
    today: 'Today',
  },
  schedule: {
    header: 'Scheduled for {{date}}, {{time}}',
    text: 'We will remind you when it’s time to start preparing the order',
  },
};
